import React, { useEffect, useState } from 'react';
import { Switch as MatSwitch, TextField as MatTextField, Input, FormLabel, Button } from '@mui/material';
import { ToggleOn, ToggleOff } from "../../Icons/Icons"
/* import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers'; */

export function Select(props) {
    const [filled, setFilled] = useState((props.noEmpty || props.value) ? true : false);
    useEffect(() => {
    },[props.options])
    const changed = (e) => {
            setFilled(e.target.value);
    };
    return (
        <div>
        <div className={'selectInput' + (props.label ? '' : ' noLabel')}>
            <Input 
                    className={ "InputSelect "+ props.className + ' graySelect selectInput' + (props.disabled ? ' disabled' : '') + (props.error ? ' error' : '')}
                    type="select"
                    name={props.name}
                    onChange={e => {
                        changed(e);
                        if (props.onChange != null) {
                            props.onChange(e);
                        }
                    }
                    }
                    id={props.id}
                    disabled={props.disabled}
                    value={props.value}
                    errorStyle = {{
                        marginTop:'20px',
                        height:'20px',
                        fontSize:'50px',
                        color:"blue"
                      }}
                    error={props.error}
               
                >
                    {props.noEmpty ? null : <option></option>}
                {props.options.map(o => {
                    return(
                        <option value={o[props.property]}>
                            {o[props.display]}
                        </option>
                    )
                })}
                
            </Input>
            {props.label ?
                <FormLabel className={(filled ? 'hasValue ' : '') + 'inlineSelect' + (props.error ? ' error' : '')}>{props.label}</FormLabel>
                : null
            }
           
            </div>
            {props.error ?
                <div className='selectError'> {props.error}</div>
                : null
            }
        </div>
    );
}
export function Switch(props) {
    return (
        <div className="d-flex justify-content-between switch-input">
            <FormLabel>{props.label}</FormLabel>
            <MatSwitch 
                {...props}
            />
        </div>
        );
}
export function ToggleSwitch(props) {
    const [isToggleOn, setToggle] = useState(props.state ? props.state : false)
    var toggle = () => {
        setToggle(!isToggleOn)
        props.stateChanged(!isToggleOn)
        // return !isToggleOn
    }
    // const toggle = () => setToggle(!isToggleOn)
   
    return (
        // <>
            <div onClick={() => toggle()} className='toggleSwitch flex f-center clickable'>
                {isToggleOn ? <ToggleOn size={38}  /> : <ToggleOff size={38} />}
            </div>
        
        );
}
export function MatText(props) {
    return (
        <div className="selectInput">
            <MatTextField
                className={(props.variant ? ( 'textfield ' + props.className + 'selectInput ' + props.variant) : (props.className + ' textfield textfield-default ')) + (props.multiline ? ' multiline-input' : '')}
                variant={props.variant}
                multiline={props.multiline}
                inputProps={{
                    style: {
                      padding: 12
                    }
                 }}
                fullWidth
                onChange={props.onChange}
                value={props.value}
                label={props.label}
                disabled={props.disabled}
                error={props.error}
                type={props.type}
                helperText={props.helperText}
                id={props.id}
        />
    </div>
       )
}
export function Weight(props) {
    const [value, setValue] = useState(props.value);
    const [index, setIndex] = useState(props.index);
    const [weight, setWeight] = useState(null);
    const [lbs, setLbs] = useState(null);
    const [ozs, setOzs] = useState(null);
    const [displayLbs, setDisplayLbs] = useState(null);
    const [displayOzs, setDisplayOzs] = useState(null);
    useEffect(() => {
        
       
    }, []);
    useEffect(() => {
        if (props.value != null
            && props.value != 0) {
            setWeight(props.value);
            let integer = Math.trunc(props.value);
            let decimal = Number((props.value - integer).toFixed(5));
            setLbs(integer);
            setDisplayLbs(integer);
            let ounce = decimal / 0.0625;
            setOzs(ounce);
            setDisplayOzs(ounce);
        }
    }, [props.value]);
    useEffect(() => {
        if (index != null) {
            props.onChange(index, weight);
        } else {
            props.onChange(weight);
        }
    }, [weight]);
    const setPounds = (newPounds) => {
        let newValue = parseFloat(newPounds);
        if (!isNaN(newValue)) {
            setLbs(newValue);
            setDisplayLbs(newValue);
            setWeight(newValue + parseFloat((0.0625 * ozs)));
        } else {
            setDisplayLbs(null);
            if (ozs != null) {
                setLbs(0);
                setWeight(0 + parseFloat((0.0625 * ozs)));
            } else {
                setLbs(null);
                setWeight(null);
            }
        }
    }
    const setOunces = (newOz) => {
        let newValue = parseFloat(newOz);
        console.log(newValue)
        console.log(isNaN(newValue))
        if (!isNaN(newValue)) {
            setOzs(newValue);
            setWeight(parseFloat(lbs) + parseFloat((0.0625 * newValue)));
            setDisplayLbs(parseFloat(lbs) + parseFloat((0.0625 * newValue)))
        } else {
            setDisplayOzs(null);
            if (lbs != null) {
                setOzs(0);
                console.log(parseFloat(lbs))
                setWeight(parseFloat(lbs));
            } else {
                setOzs(null);
                setWeight(null);
            }
        }
    }
    return (
        <div className="">
            <div className="weightLabel">{props.label}</div>
            {(props.type == null || props.type == "lbsoz") ?
                <div className="row bottomMargin">
                <div className="col-xs-12 col-sm-6">
                <MatTextField
                    className={(props.variant ? ( 'textfield ' + props.className + 'selectInput ' + props.variant) : (props.className + ' textfield textfield-default ')) + (props.multiline ? ' multiline-input' : '')}
                    // className="highWeight"
                    variant={props.variant}
                    inputProps={{
                        style: {
                          padding: 15
                        }
                     }}
                
                    fullWidth
                    onChange={e => setPounds(e.target.value)}
                    value={displayLbs}
                    label="lbs."
                    disabled={props.disabled}
                    error={props.error}
                    helperText={props.helperText}
                    />
                </div>
                    <div className="col-xs-12 col-sm-6">
                        <MatTextField
                            className={(props.variant ? ( 'textfield ' + props.className + 'selectInput ' + props.variant) : (props.className + ' textfield textfield-default ')) + (props.multiline ? ' multiline-input' : '')}
                            variant={props.variant}
                            fullWidth
                            inputProps={{
                                style: {
                                  padding: 15
                                }
                             }}
                            onChange={e => setOunces(e.target.value)}
                            value={displayOzs}
                            label="oz."
                            disabled={props.disabled}
                            error={props.error}
                           
                        />
                    </div>
                </div>
            : null}
        </div>
    )
}
export function DatePicker(props) {
    const [errorText, setErrorText] = useState(null);
    return null;
    // Commenting out bcuz KeyboardDatePicker is deprecated
    /* return (
        <div className='selectInput'>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    className={props.className + ' selectInput'}
                disableToolbar
                format="MM/dd/yyyy"
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                {...props}
                />
            </MuiPickersUtilsProvider>
            {props.errorText ?
                <div className='selectError'> {props.errorText}</div>
                : null
            }
        </div>
    ) */
}
export function SelectAdd(props) {
    const [filled, setFilled] = useState((props.noEmpty || props.value) ? true : false);
    const changed = (e) => {
        setFilled(e.target.value);
    };
    function AddClicked(e) {
        if (props.onAdd)
            props.onAdd(e);
    }
    return (
        <div>
            <div className={'selectInput' + (props.label ? '' : ' noLabel')}>
                <Input
                    className={props.className + ' graySelect selectInput' + (props.disabled ? ' disabled' : '') + (props.error ? ' error' : '')}
                    type="select"
                    name={props.name}
                    onChange={e => {
                        changed(e);
                        if (props.onChange != null) {
                            props.onChange(e);
                        }
                    }
                    }
                    id={props.id}
                    disabled={props.disabled}
                    value={props.value}
                    error={props.error}
                >
                    {props.noEmpty ? null : <option></option>}
                    {props.options.map(o => {
                        return (
                            <option
                                value={o[props.property]}>
                                {o[props.display]}
                            </option>
                        )
                    })}
                </Input>
                <Button onClick={AddClicked} className={props.className + 'graySelect selectInputAddButton col-1' + (props.disabled ? ' disabled' : '') + (props.error ? ' error' : '')}>
                    <img src="./images/ic_add.svg" alt="Add" />
                </Button>
                {props.label ?
                    <FormLabel className={(filled ? 'hasValue ' : '') + 'inlineSelect' + (props.error ? ' error' : '')}>{props.label}</FormLabel>
                    : null
                }
            </div>
            {props.error ?
                <div className='selectError'> {props.error}</div>
                : null
            }
        </div>
    );
}